/**
 * Delays running JS code for x number of milliseconds
 * @param ms number
 * @returns Promise<any>
 */
export const delay = async (ms: number): Promise<any> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
